export class AuthV2RespondChallengeRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "email",
            "baseName": "email",
            "type": "string",
            "format": ""
        },
        {
            "name": "challengeName",
            "baseName": "challengeName",
            "type": "string",
            "format": ""
        },
        {
            "name": "session",
            "baseName": "session",
            "type": "string",
            "format": ""
        },
        {
            "name": "challengeResponses",
            "baseName": "challengeResponses",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AuthV2RespondChallengeRequest.attributeTypeMap;
    }
    constructor() {
    }
}
